import { CaseModel } from "@ortho-next/nextray-core";
import { Vector2 } from "three";
import { AppModel } from "../Models/AppModel";
import { bindedModel } from "../Models/BindedModel";
import { ViewPlanImages, ViewPlanUtils } from "../Utils/ViewPlanUtils";
import { Main } from "./Main";

export async function getViewPlanImages(caseModel: CaseModel, resolution: Vector2): Promise<[ViewPlanImages, AppModel]> {
	const tempDiv: HTMLDivElement = document.createElement('div');
	document.body.appendChild(tempDiv); // to fix canvas style calculations

	const main = new Main(tempDiv);
	await loadScene(main, caseModel);

	forceLayers();

	const viewPlanUtils = new ViewPlanUtils(main, main['_context']);
	const result = viewPlanUtils.generateImages(main.model.stateType, resolution);

	tempDiv.remove();

	return [result, main.model];
}

async function loadScene(main: Main, caseModel: CaseModel): Promise<void> {
	await main.loadScenes(caseModel);

	let isFitboneLoadedAP = !main.hasAP || !bindedModel.isFitboneInserted;
	let isFitboneLoadedLT = !main.hasLT || !bindedModel.isFitboneInserted;

	return new Promise((resolve) => {
		if (isFitboneLoadedAP && isFitboneLoadedLT) resolve();

		main.bridge.addEventListener("onResult", (e) => {
			isFitboneLoadedAP ||= e.args === 'fitboneLoadedAP';
			isFitboneLoadedLT ||= e.args === 'fitboneLoadedLT';

			if (isFitboneLoadedAP && isFitboneLoadedLT) resolve();
		});
	});
}

function forceLayers(): void {
	bindedModel.layer_lines = false;
	bindedModel.layer_goniometers = false;
	bindedModel.layer_labels = true;
	bindedModel.layer_mechAxis_weightBearing = true;
	bindedModel.layer_mechAxis_mechanical = true;
	bindedModel.layer_mechAxis_anatomical = true;
	bindedModel.layer_contralateral_all = true;
	bindedModel.layer_fitbone = true;
	bindedModel.layer_grid = false;
	bindedModel.layer_grid_center = false;
	bindedModel.layer_plane = true;
}
